/**
 * Checks if all time units in an ISO string are 0, i.e.
 * no (valid) time.
 *
 * Parses iso string like 2023-04-06T00:00:00.000Z by
 * splitting on 'T' and slicing off the trailing 'Z'
 */
export const isTimeAllZero = (date: string | null | undefined): boolean => {
  const timeSegment = date?.split("T")?.[1];
  return timeSegment ? !!timeSegment.slice(0, -1).match("00:00:00.000") : true;
};
